import React from 'react';
import { Button } from '@material-ui/core';
import {
  AuthRoles,
  readableRegistrationState,
  readableRegistrationStatus,
  Roles,
} from 'config';
import { Control, useForm, DeepMap, FieldError } from 'react-hook-form';
import TranslatedText from '../../../../components/atoms/translated_text';
import {
  AppSelect,
  AppTextField,
} from '../../../../components/molecules/form_controls';
import GridLayout from '../../../../components/molecules/grid_layout';
import { Translations } from '../../configuration';
import _ from 'lodash';
import { useHistory } from 'react-router';
import NavigationConfig from 'navigation/config';
import Switch from 'components/molecules/form_controls/switch';

interface FormFields {
  vat_num: string | null;
  status: string | null;
  state: string | null;
  personal: boolean;
}

interface IProps {
  vat_number: string | null;
  status: string | null;
  state: string | null;
  personal: boolean;
  role: Roles;
}

const FilterForm = (props: IProps) => {
  const history = useHistory();
  const defaultValues = {
    vat_num: props.vat_number ? props.vat_number : null,
    status: props.status ? props.status : null,
    state: props.state ? props.state : null,
    personal: props.personal,
  };
  const { control, errors, handleSubmit, reset } = useForm<FormFields>({
    defaultValues: defaultValues,
  });

  const onSubmit = (data: any) => {
    let query = [];
    if (data.vat_num)
      query.push({
        key: 'vat_num',
        value: data.vat_num,
      });
    if (data.status)
      query.push({
        key: 'status',
        value: data.status,
      });
    if (data.state)
      query.push({
        key: 'state',
        value: data.state,
      });
    if (data.personal)
      query.push({
        key: 'personal',
        value: data.personal,
      });
    let queryString = '';
    query.map((query, index) => {
      if (index === 0) queryString += `?${query.key}=${query.value}`;
      else queryString += `&${query.key}=${query.value}`;
    });
    history.push(NavigationConfig.registrationListPage().path + queryString);
  };

  const clearFilter = () => {
    history.push(NavigationConfig.registrationListPage().path);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <GridLayout
        elements={
          [
            {
              element: renderVatNumberField(errors, control),
              size: 12,
              id: 'vatNumber',
            },
            {
              element: renderStatusField(errors, control),
              size: 6,
              id: 'status',
            },
            {
              element: renderStateField(errors, control),
              size: 6,
              id: 'state',
            },
            ...(props.role === AuthRoles.Agent
              ? [
                  {
                    element: renderCheckBox(errors, control),
                    size: 4,
                    id: 'personal',
                  },
                  {
                    element: <span></span>,
                    size: 4,
                    id: 'space',
                  },
                ]
              : [
                  {
                    element: <span></span>,
                    size: 8,
                    id: 'space',
                  },
                ]),
            {
              element: (
                <Button
                  variant="contained"
                  color="primary"
                  style={{ width: '100%', marginBottom: '1rem' }}
                  onClick={clearFilter}
                >
                  <TranslatedText textMap={Translations.clear} />
                </Button>
              ),
              size: 2,
              id: 'search',
            },
            {
              element: (
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  style={{ width: '100%', marginBottom: '1rem' }}
                >
                  <TranslatedText textMap={Translations.search} />
                </Button>
              ),
              size: 2,
              id: 'clear',
            },
          ] as any
        }
      />
    </form>
  );
};

const renderVatNumberField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  return (
    <AppTextField
      variant="outlined"
      margin="normal"
      fullWidth
      id="vat_num"
      label={<TranslatedText textMap={Translations.vat_number} />}
      error={'vat_num' in errors}
      name="vat_num"
      control={control}
      rules={{}}
      helperText={errors.vat_num && errors.vat_num.message}
    />
  );
};

const renderStatusField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  var select_options: any[] = [];
  select_options.push({
    id: null,
    label: Translations.status.English,
  });
  readableRegistrationStatus.map((value, index) => {
    select_options.push({
      id: `${index}`,
      label: value,
    });
  });
  return (
    <AppSelect
      variant="outlined"
      margin="normal"
      fullWidth
      label={<TranslatedText textMap={Translations.status} />}
      id="status"
      name="status"
      error={'status' in errors}
      control={control}
      rules={{}}
      options={select_options}
      helperText={errors.status && errors.status.message}
    />
  );
};

const renderStateField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  let select_options = [];
  select_options.push({
    id: null,
    label: Translations.state.English,
  });
  for (let state in readableRegistrationState) {
    select_options.push({
      id: state,
      label: _.get(readableRegistrationState, state),
    });
  }
  return (
    <AppSelect
      variant="outlined"
      margin="normal"
      fullWidth
      label={<TranslatedText textMap={Translations.state} />}
      id="state"
      name="state"
      error={'state' in errors}
      control={control}
      rules={{}}
      options={select_options as any}
      helperText={errors.state && errors.state.message}
    />
  );
};

const renderCheckBox = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  return (
    <Switch
      label={'Personal Registrations'}
      id="personal"
      name="personal"
      control={control}
      rules={{}}
      color={'primary'}
    />
  );
};

export default FilterForm;
